"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET_PERIOD_OPTIONS = exports.STORAGE_OPTIONS = exports.USERS_OPTIONS = exports.SLA_TURNAROUND_OPTIONS = exports.AMENDMENTS_OPTIONS = void 0;
var AMENDMENTS_OPTIONS = [{
  value: 3,
  label: '3'
}, {
  value: 5,
  label: '5'
}, {
  value: 10,
  label: '10'
}];
exports.AMENDMENTS_OPTIONS = AMENDMENTS_OPTIONS;
var SLA_TURNAROUND_OPTIONS = [{
  value: 6,
  label: '6'
}, {
  value: 12,
  label: '12'
}, {
  value: 24,
  label: '24'
}, {
  value: 48,
  label: '48'
}];
exports.SLA_TURNAROUND_OPTIONS = SLA_TURNAROUND_OPTIONS;
var USERS_OPTIONS = [{
  label: '3',
  value: 3
}, {
  label: '5',
  value: 5
}, {
  label: '10',
  value: 10
}, {
  label: '20',
  value: 20
}, {
  label: '50',
  value: 50
}, {
  label: 'UNLIMITED',
  value: -1
}];
exports.USERS_OPTIONS = USERS_OPTIONS;
var STORAGE_OPTIONS = [{
  label: '20GB',
  value: 20
}, {
  label: '50GB',
  value: 50
}, {
  label: '100GB',
  value: 100
}, {
  label: '500GB',
  value: 500
}, {
  label: 'UNLIMITED',
  value: -1
}];
exports.STORAGE_OPTIONS = STORAGE_OPTIONS;
var RESET_PERIOD_OPTIONS = [{
  value: 'MONTHLY',
  label: 'MONTHLY'
}, {
  value: 'NONE',
  label: 'NONE'
}];
exports.RESET_PERIOD_OPTIONS = RESET_PERIOD_OPTIONS;